import { render, staticRenderFns } from "./TabProperties.vue?vue&type=template&id=28c4f46a&scoped=true&"
import script from "./TabProperties.vue?vue&type=script&lang=js&"
export * from "./TabProperties.vue?vue&type=script&lang=js&"
import style0 from "./TabProperties.vue?vue&type=style&index=0&id=28c4f46a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c4f46a",
  null
  
)

export default component.exports